import cls from 'classnames';
import { useTranslation } from 'next-i18next';
import React from 'react';

import { CHINESE_REG, ETagValue } from './constants';
import styles from './index.module.scss';
import npcIcon from '../../../assets/Global/npc.svg';
import userIcon from '../../../assets/Global/user.svg';
import { useAppSelector } from '../../../state';
import { RootState } from '../../../state/rootReducers';
import { LocalImage } from '../../Image';

interface AvatarTagProps {
  value: ETagValue;
  onClick?: () => void;
  showBackground?: boolean;
  avatarSelector?: (state: RootState) => string | undefined;
  nicknameSelector?: (state: RootState) => string | undefined;
}

// 添加文本截断函数
const truncateText = (text: string, maxCount: number = 12): string => {
  let count = 0;
  let result = '';

  for (const char of text) {
    const charCount = CHINESE_REG.test(char) ? 2 : 1; // 中文字符占2个字符，英文字符占1个字符
    if (count + charCount > maxCount) {
      return result + '...';
    }
    count += charCount;
    result += char;
  }

  return result;
};

export const AvatarTag: React.FC<AvatarTagProps> = ({
  value,
  onClick,
  showBackground = true,
  avatarSelector = (state) => state.edit.imgInfo.face_img_url,
  nicknameSelector = (state) => state.edit.settingInfo.npc_name,
}) => {
  const { t } = useTranslation();
  const npcAvatarUrl = useAppSelector(avatarSelector);
  const npcName = useAppSelector(nicknameSelector) || t('edit_default_npc_name');
  const userName = t('edit_default_user_name');

  // 获取显示文本
  const displayText = value === ETagValue.NPC ? npcName : userName;
  // 截断文本
  const truncatedText = truncateText(displayText);

  return (
    <span
      className={cls(styles.tag, {
        [styles.noBackground]: !showBackground,
        [styles.hover]: onClick,
      })}
      onClick={onClick}
      contentEditable={false}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      {value === ETagValue.NPC ? (
        npcAvatarUrl ? (
          <img src={npcAvatarUrl} width={20} height={20} />
        ) : (
          <LocalImage src={npcIcon} width={20} height={20} />
        )
      ) : (
        <LocalImage src={userIcon} width={20} height={20} />
      )}
      <span
        className={styles.tagText}
        title={displayText} // 添加 title 属性，鼠标悬停时显示完整文本
      >
        {truncatedText}
      </span>
    </span>
  );
};
